module.exports = __webpack_public_path__ + "static/media/phone_trackers_preview.bf85b4d4.svg";